import { ARCHIVE_BLOCK, ARCHIVE_BLOCK_EXTENSION, CALL_TO_ACTION, CONTENT, MEDIA_BLOCK } from "./blocks";
import { PRODUCT_CATEGORIES } from "./categories";
import { PRODUCT_BRANDS } from "./brands";
import { META } from "./meta";
import { GALLERY, VARIATION_GALLERY } from "./gallery";

export const PRODUCTS = `
  query Products {
    Products(limit: 300) {
      docs {
        slug
      }
    }
  }
`;

export const PRODUCT = `
  query Product($slug: String, $draft: Boolean) {
    Products(where: { slug: { equals: $slug}}, limit: 1, draft: $draft) {
      docs {
        id
        title
        ${PRODUCT_CATEGORIES}
        ${PRODUCT_BRANDS}
        layout {
          ${CALL_TO_ACTION}
          ${CONTENT}
          ${MEDIA_BLOCK}
          ${ARCHIVE_BLOCK}
        }
        price
        salesPrice
        sku
        slug
        url
        description
        stock
        featuredProduct
        priceJSON
        ${GALLERY}
        detailsCare(depth: 1)
        sizeInfo
        relatedProducts {
          id
          price
          salesPrice
          slug
          title
          ${META}
        }
        availableSizes {
          id
          name
          code
        }
        availableColors {
          id
          name
          code
        }
        selectedColor{
          id
          name
          code
        }
        selectedSize{
          id
          name
          code
        }
        ${META}
        variations { 
            name
            sku
            ${VARIATION_GALLERY}
        }
      }
    }
  }
`;

export const PRODUCT_PAYWALL = `
  query Product($slug: String, $draft: Boolean) {
    Products(where: { slug: { equals: $slug}}, limit: 1, draft: $draft) {
      docs {
        paywall {
          ${CALL_TO_ACTION}
          ${CONTENT}
          ${MEDIA_BLOCK}
          ${ARCHIVE_BLOCK}
        }
      }
    }
  }
`;

export const PRODUCTS_FEATURED = `
 query Products {
    Products(where: { featuredProduct: { equals: true}}, limit: 15) {
      docs {
        id
        title
        ${PRODUCT_CATEGORIES}
        layout {
          ${CALL_TO_ACTION}
          ${CONTENT}
          ${MEDIA_BLOCK}
          ${ARCHIVE_BLOCK}
        }
        slug
        stock
        price
        salesPrice
        sku
        featuredProduct
        priceJSON
        ${GALLERY}
        detailsCare
        sizeInfo
        relatedProducts {
          id
          slug
          title
          ${META}
        }
         availableSizes {
          id
          name
          code
        }
        availableColors {
          id
          name
          code
        }
        ${META}
      }
    }
  }
`;

export const PRODUCT_ID = `
    {
        id
        title
        slug
        stock
        price
        sku
        featuredProduct
        priceJSON
        detailsCare
        sizeInfo
        ${META}
      }
`;
